import { AnimatedLogo } from "@/components/AnimatedLogo";

export default function BrandMotionMock() {
  return (
    <div className="min-h-screen bg-[#e2e8f0] p-10 space-y-8 font-sans" data-testid="brand-motion-mock">
      <div className="text-[11px] font-black uppercase tracking-[0.2em] text-slate-500">Login — animated lockup (radar ping travels along the teal sweep)</div>
      <div className="bg-[#f4f4f5] rounded-2xl p-12 flex flex-col items-center gap-6">
        <AnimatedLogo variant="lockup" height={110}/>
        <div className="font-black text-3xl text-[#0B1C2D]">Sign in</div>
      </div>
      <div className="text-[11px] font-black uppercase tracking-[0.2em] text-slate-500">Mark only (mobile / favicon-size preview)</div>
      <div className="flex gap-8 items-end">
        <div className="bg-white rounded-2xl p-8"><AnimatedLogo variant="mark" height={160}/></div>
        <div className="bg-[#0B1C2D] rounded-2xl p-8"><span className="inline-flex bg-white rounded-xl p-3"><AnimatedLogo variant="mark" height={72}/></span></div>
      </div>
    </div>
  );
}
